import type { Application } from '@data/hooks/api/use-applications-api/use-applications-api';

/**
 * The distinct access types across an application's products (e.g.
 * "Educator only", "Educators and Student"), in the order they first appear.
 * Read from the products' own `accessType`, so it is empty when the API
 * supplies none.
 */
export function getAccessTags(
  application: Pick<Application, 'products'>
): string[] {
  return [
    ...new Set(
      (application.products ?? [])
        .map((product) => product.accessType)
        .filter((accessType): accessType is string => !!accessType)
    ),
  ];
}
